export default "__VITE_ASSET__DaRl_NK7__"